// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.map-container {
  width: 100%;
  height: auto;
  position: relative;
  overflow: hidden;
  margin: 20px auto;
  /* Centered block */
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 0.05);
}

.map-svg {
  width: 100%;
  height: 100%;
  display: block;
}

.map-path {
  stroke: #666;
  opacity: 0.8;
}

.map-path:hover {
  opacity: 1;
  /* fill is handled by inline style now */
  filter: brightness(1.2);
}

.map-path.visited {
  opacity: 0.9;
}

.map-path.visited:hover {
  opacity: 1;
  filter: brightness(1.2);
}

/* Sovereignty Badges */
.sovereignty-badges {
  position: absolute;
  top: 50%;
  right: 20px;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  gap: 15px;
  z-index: 5;
}

.sovereignty-badge {
  display: flex;
  align-items: center;
  gap: 10px;
  background: rgba(20, 20, 20, 0.6);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  padding: 10px 15px;
  border-radius: 50px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
  cursor: default;
}



.badge-icon {
  font-size: 1.2rem;
}

.sovereignty-badge:hover {
  background: rgba(40, 40, 40, 0.8);
  transform: translateX(-5px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
}

.badge-icon {
  font-size: 1.2rem;
}

.badge-text {
  display: flex;
  flex-direction: column;
  line-height: 1.2;
}

.badge-text strong {
  font-size: 0.9rem;
}

.badge-text small {
  font-size: 0.7rem;
  opacity: 0.7;
}

@media (max-width: 768px) {
  .sovereignty-badges {
    top: 20px;
    right: 10px;
    transform: none;
  }

  .sovereignty-badge {
    padding: 8px 12px;
  }

  .badge-text small {
    display: none;
  }
}

/* Map Stats Badge */
.map-stats-badge {
  position: absolute;
  top: 20px;
  left: 20px;
  background: rgba(20, 20, 20, 0.7);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  padding: 15px 20px;
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  z-index: 10;
  min-width: 200px;
  transition: transform 0.3s ease;
}

.map-stats-badge:hover {
  transform: translateY(-2px);
  background: rgba(30, 30, 30, 0.85);
}

.stats-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.stats-title {
  font-size: 0.9rem;
  font-weight: 600;
  color: #fff;
  opacity: 0.9;
}

.stats-percent {
  font-size: 1.5rem;
  font-weight: 700;
  font-family: 'Google Sans Bold', sans-serif;
  line-height: 1;
}

.stats-detail {
  font-size: 0.8rem;
  opacity: 0.7;
  margin-bottom: 8px;
  color: #fff;
}

.stats-progress-bg {
  width: 100%;
  height: 6px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 3px;
  overflow: hidden;
}

.stats-progress-fill {
  height: 100%;
  border-radius: 3px;
  transition: width 1s ease-out;
}

/* Position adjustments for specific maps */
.map-container.map-portrait .map-stats-badge {
  bottom: 20px;
  right: 20px;
  top: auto;
  left: auto;
}

.map-container.map-landscape .map-stats-badge {
  bottom: 20px;
  top: auto;
  left: 20px;
}

@media (max-width: 768px) {
  .map-stats-badge {
    padding: 12px 15px;
    min-width: 160px;
  }

  .stats-percent {
    font-size: 1.2rem;
  }
}

.island-group {
  animation: pulse 2s ease-in-out infinite;
}

.island-group circle {
  transition: all 0.3s ease;
}

.island-group:hover circle {
  r: 5;
  filter: brightness(1.3);
}

@keyframes pulse {

  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0.7;
  }
}

/* Location Card (Fixed Preview) */
.location-card {
  position: fixed;
  top: 0;
  left: 0;
  width: 280px;
  background: rgba(20, 20, 20, 0.9);
  backdrop-filter: blur(15px);
  -webkit-backdrop-filter: blur(15px);
  padding: 15px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.6);
  z-index: 9999;
  pointer-events: none;
  opacity: 0;
  transform: scale(0.95);
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.location-card.active {
  transform: scale(1);
  opacity: 1;
  pointer-events: none;
}

.location-placeholder {
  font-style: italic;
  text-align: center;
  padding: 10px;
  opacity: 0.7;
}

.location-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  padding-bottom: 8px;
}

.location-header h3 {
  margin: 0;
  font-size: 1.2rem;
  font-weight: 600;
}

.location-year {
  font-size: 0.8rem;
  color: #fff;
  padding: 2px 8px;
  border-radius: 12px;
  font-weight: bold;
}

.location-note {
  font-size: 0.9rem;
  margin: 0 0 12px 0;
  line-height: 1.4;
}

.location-gallery-preview {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.main-preview-image {
  position: relative;
  width: 100%;
  height: 150px;
  overflow: hidden;
  border-radius: 8px;
}

.main-preview-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
  border: 1px solid transparent;
}

.location-card.active .main-preview-image img {
  transform: scale(1.05);
}

.more-photos-badge {
  position: absolute;
  bottom: 5px;
  right: 5px;
  background: rgba(0, 0, 0, 0.7);
  color: #fff;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: bold;
}

.gallery-hint {
  font-size: 0.75rem;
  text-align: center;
  margin-top: 5px;
  opacity: 0.6;
}

.no-photos {
  text-align: center;
  padding: 20px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  font-size: 0.8rem;
}

@media (max-width: 768px) {
  .location-card {
    width: calc(100% - 40px);
    bottom: 10px;
    left: 20px;
    padding: 10px;
  }

  .main-preview-image {
    height: 120px;
  }
}

.map-loading,
.map-error {
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  text-align: center;
}

.map-error {
  color: #ff6b6b;
}`, "",{"version":3,"sources":["webpack://./src/components/travel/MapRenderer.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,UAAU;EACV,wCAAwC;EACxC,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,uBAAuB;AACzB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iCAAiC;EACjC,0BAA0B;EAC1B,kCAAkC;EAClC,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,yBAAyB;EACzB,eAAe;AACjB;;;;AAIA;EACE,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE;IACE,SAAS;IACT,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,iCAAiC;EACjC,0BAA0B;EAC1B,kCAAkC;EAClC,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;EAC3C,yCAAyC;EACzC,WAAW;EACX,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;EACX,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA,2CAA2C;AAC3C;EACE,YAAY;EACZ,WAAW;EACX,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,UAAU;AACZ;;AAEA;EACE;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,IAAI;EACJ,uBAAuB;AACzB;;AAEA;;EAEE;;IAEE,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;AACF;;AAEA,kCAAkC;AAClC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,0CAA0C;EAC1C,aAAa;EACb,oBAAoB;EACpB,UAAU;EACV,sBAAsB;EACtB,kDAAkD;AACpD;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,iDAAiD;EACjD,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,qCAAqC;EACrC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE;IACE,wBAAwB;IACxB,YAAY;IACZ,UAAU;IACV,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;;EAEE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".map-container {\n  width: 100%;\n  height: auto;\n  position: relative;\n  overflow: hidden;\n  margin: 20px auto;\n  /* Centered block */\n  border-radius: 10px;\n  background-color: rgba(255, 255, 255, 0.05);\n}\n\n.map-svg {\n  width: 100%;\n  height: 100%;\n  display: block;\n}\n\n.map-path {\n  stroke: #666;\n  opacity: 0.8;\n}\n\n.map-path:hover {\n  opacity: 1;\n  /* fill is handled by inline style now */\n  filter: brightness(1.2);\n}\n\n.map-path.visited {\n  opacity: 0.9;\n}\n\n.map-path.visited:hover {\n  opacity: 1;\n  filter: brightness(1.2);\n}\n\n/* Sovereignty Badges */\n.sovereignty-badges {\n  position: absolute;\n  top: 50%;\n  right: 20px;\n  transform: translateY(-50%);\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  z-index: 5;\n}\n\n.sovereignty-badge {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  background: rgba(20, 20, 20, 0.6);\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n  padding: 10px 15px;\n  border-radius: 50px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  transition: all 0.3s ease;\n  cursor: default;\n}\n\n\n\n.badge-icon {\n  font-size: 1.2rem;\n}\n\n.sovereignty-badge:hover {\n  background: rgba(40, 40, 40, 0.8);\n  transform: translateX(-5px);\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);\n}\n\n.badge-icon {\n  font-size: 1.2rem;\n}\n\n.badge-text {\n  display: flex;\n  flex-direction: column;\n  line-height: 1.2;\n}\n\n.badge-text strong {\n  font-size: 0.9rem;\n}\n\n.badge-text small {\n  font-size: 0.7rem;\n  opacity: 0.7;\n}\n\n@media (max-width: 768px) {\n  .sovereignty-badges {\n    top: 20px;\n    right: 10px;\n    transform: none;\n  }\n\n  .sovereignty-badge {\n    padding: 8px 12px;\n  }\n\n  .badge-text small {\n    display: none;\n  }\n}\n\n/* Map Stats Badge */\n.map-stats-badge {\n  position: absolute;\n  top: 20px;\n  left: 20px;\n  background: rgba(20, 20, 20, 0.7);\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n  padding: 15px 20px;\n  border-radius: 16px;\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);\n  z-index: 10;\n  min-width: 200px;\n  transition: transform 0.3s ease;\n}\n\n.map-stats-badge:hover {\n  transform: translateY(-2px);\n  background: rgba(30, 30, 30, 0.85);\n}\n\n.stats-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.stats-title {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: #fff;\n  opacity: 0.9;\n}\n\n.stats-percent {\n  font-size: 1.5rem;\n  font-weight: 700;\n  font-family: 'Google Sans Bold', sans-serif;\n  line-height: 1;\n}\n\n.stats-detail {\n  font-size: 0.8rem;\n  opacity: 0.7;\n  margin-bottom: 8px;\n  color: #fff;\n}\n\n.stats-progress-bg {\n  width: 100%;\n  height: 6px;\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 3px;\n  overflow: hidden;\n}\n\n.stats-progress-fill {\n  height: 100%;\n  border-radius: 3px;\n  transition: width 1s ease-out;\n}\n\n/* Position adjustments for specific maps */\n.map-container.map-portrait .map-stats-badge {\n  bottom: 20px;\n  right: 20px;\n  top: auto;\n  left: auto;\n}\n\n.map-container.map-landscape .map-stats-badge {\n  bottom: 20px;\n  top: auto;\n  left: 20px;\n}\n\n@media (max-width: 768px) {\n  .map-stats-badge {\n    padding: 12px 15px;\n    min-width: 160px;\n  }\n\n  .stats-percent {\n    font-size: 1.2rem;\n  }\n}\n\n.island-group {\n  animation: pulse 2s ease-in-out infinite;\n}\n\n.island-group circle {\n  transition: all 0.3s ease;\n}\n\n.island-group:hover circle {\n  r: 5;\n  filter: brightness(1.3);\n}\n\n@keyframes pulse {\n\n  0%,\n  100% {\n    opacity: 1;\n  }\n\n  50% {\n    opacity: 0.7;\n  }\n}\n\n/* Location Card (Fixed Preview) */\n.location-card {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 280px;\n  background: rgba(20, 20, 20, 0.9);\n  backdrop-filter: blur(15px);\n  -webkit-backdrop-filter: blur(15px);\n  padding: 15px;\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.6);\n  z-index: 9999;\n  pointer-events: none;\n  opacity: 0;\n  transform: scale(0.95);\n  transition: opacity 0.2s ease, transform 0.2s ease;\n}\n\n.location-card.active {\n  transform: scale(1);\n  opacity: 1;\n  pointer-events: none;\n}\n\n.location-placeholder {\n  font-style: italic;\n  text-align: center;\n  padding: 10px;\n  opacity: 0.7;\n}\n\n.location-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  padding-bottom: 8px;\n}\n\n.location-header h3 {\n  margin: 0;\n  font-size: 1.2rem;\n  font-weight: 600;\n}\n\n.location-year {\n  font-size: 0.8rem;\n  color: #fff;\n  padding: 2px 8px;\n  border-radius: 12px;\n  font-weight: bold;\n}\n\n.location-note {\n  font-size: 0.9rem;\n  margin: 0 0 12px 0;\n  line-height: 1.4;\n}\n\n.location-gallery-preview {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.main-preview-image {\n  position: relative;\n  width: 100%;\n  height: 150px;\n  overflow: hidden;\n  border-radius: 8px;\n}\n\n.main-preview-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.5s ease;\n  border: 1px solid transparent;\n}\n\n.location-card.active .main-preview-image img {\n  transform: scale(1.05);\n}\n\n.more-photos-badge {\n  position: absolute;\n  bottom: 5px;\n  right: 5px;\n  background: rgba(0, 0, 0, 0.7);\n  color: #fff;\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-size: 10px;\n  font-weight: bold;\n}\n\n.gallery-hint {\n  font-size: 0.75rem;\n  text-align: center;\n  margin-top: 5px;\n  opacity: 0.6;\n}\n\n.no-photos {\n  text-align: center;\n  padding: 20px;\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 8px;\n  font-size: 0.8rem;\n}\n\n@media (max-width: 768px) {\n  .location-card {\n    width: calc(100% - 40px);\n    bottom: 10px;\n    left: 20px;\n    padding: 10px;\n  }\n\n  .main-preview-image {\n    height: 120px;\n  }\n}\n\n.map-loading,\n.map-error {\n  min-height: 200px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  text-align: center;\n}\n\n.map-error {\n  color: #ff6b6b;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
